async function createPrimer(properties) {
    return fetch('/primers', {
        method: 'POST',
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(properties)
    });
}

async function updatePrimer(id, {
    name,
    volume,
    sampleMap
}) {
    return fetch(`/primers/${id}`, {
        method: 'PATCH',
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            name,
            volume,
            sampleMap
        })
    });
}

async function deletePrimer(id) {
    return fetch(`/primers/${id}`, {
        method: 'DELETE',
    });
}

export {
    createPrimer,
    updatePrimer,
    deletePrimer
}